export const FETCH_BLOCKADES_REQUEST = 'BLOCKADES/FETCH_BLOCKADES_REQUEST';
export const FETCH_BLOCKADES_SUCCESS = 'BLOCKADES/FETCH_BLOCKADES_SUCCESS';
export const FETCH_BLOCKADES_FAILURE = 'BLOCKADES/FETCH_BLOCKADES_FAILURE';

export const CREATE_BLOCKADE_REQUEST = 'BLOCKADES/CREATE_BLOCKADE_REQUEST';
export const CREATE_BLOCKADE_SUCCESS = 'BLOCKADES/CREATE_BLOCKADE_SUCCESS';
export const CREATE_BLOCKADE_FAILURE = 'BLOCKADES/CREATE_BLOCKADE_FAILURE';

export const DELETE_BLOCKADE_REQUEST = 'BLOCKADES/DELETE_BLOCKADE_REQUEST';
export const DELETE_BLOCKADE_SUCCESS = 'BLOCKADES/DELETE_BLOCKADE_SUCCESS';
export const DELETE_BLOCKADE_FAILURE = 'BLOCKADES/DELETE_BLOCKADE_FAILURE';
